import React, { Fragment } from 'react'
import { graphql, StaticQuery } from 'gatsby'
import MachineLink from './machine-link'

import { parseMachineNavigationData } from '../../utils/selectors';

const Index = ({ machine }) => (
  <Fragment>
    <StaticQuery query = { query } render = { data => <MachineLink data = { parseMachineNavigationData(data.allPrismicMachine) } machine = { machine } /> } />
  </Fragment>
);

const query = graphql`
  query GetAllMachinesForLinks {
    allPrismicMachine {
      edges {
        node {
          uid
          data {
            machine_name {
              html
              text
            }
            navigation_image {
              url
            }
            treat_as_single_machine
            espresso_count
            milk_systems
            milk_systems_2
            milk_systems_3
            accessories
            features
            body1 {
              items {
                machine_type {
                  document {
                    ...MachineTypeNavigation
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export default Index
